import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';

const items = [
  { src: '/assets/float-tshirt.webp', alt: 'Majica s potiskom', cls: 'left-[6%] top-[4%] w-[52%] z-20', delay: 0, dur: 6 },
  { src: '/assets/float-tote.webp', alt: 'Nakupovalna torba s potiskom', cls: 'right-[0%] top-[18%] w-[42%] z-10', delay: 0.8, dur: 7 },
  { src: '/assets/float-cap.webp', alt: 'Kapa s potiskom', cls: 'left-[0%] bottom-[10%] w-[36%] z-30', delay: 1.6, dur: 5.5 },
  { src: '/assets/float-bottle.webp', alt: 'Steklenica s potiskom', cls: 'right-[14%] bottom-[0%] w-[22%] z-30', delay: 0.4, dur: 6.5 }
];

export const FloatingMerch = () => {
  const reduce = useReducedMotion();
  return (
    <div className="relative w-full max-w-[560px] aspect-square mx-auto" data-testid="hero-floating-merch">
      <div className="absolute inset-[10%] rounded-full bg-gradient-to-br from-cyan-500/20 via-fuchsia-500/15 to-yellow-400/20 blur-3xl pointer-events-none" />
      {items.map((item, i) => (
        <motion.img
          key={item.src}
          src={item.src}
          alt={item.alt}
          className={`absolute ${item.cls} drop-shadow-[0_30px_40px_rgba(0,0,0,0.7)] select-none pointer-events-none`}
          initial={reduce ? false : { opacity: 0, y: 40, scale: 0.9 }}
          animate={reduce ? { opacity: 1 } : { opacity: 1, y: [0, -14, 0], scale: 1 }}
          transition={reduce ? undefined : {
            opacity: { duration: 0.8, delay: 0.2 + i * 0.15 },
            scale: { duration: 0.8, delay: 0.2 + i * 0.15 },
            y: { duration: item.dur, delay: item.delay, repeat: Infinity, ease: 'easeInOut' }
          }}
          draggable={false}
        />
      ))}
    </div>
  );
};
